import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Pie } from 'react-chartjs-2';

import { hideResidentsCheck } from '../../../utilities/Generic.js'

import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { request, handleRequestErrors } from '../../../helpers/Requests'

class PeopleOnSite extends Component {
  removeResidentsIfNeeded(array) {
    if (this.state.hideResidents) {
      // Residents are the second item in the arrays, so we can just filter them out directly by position
      array.splice(1, 1)
    }

    return array
  }

  render() {
    const { json, loaded, error, unauthorized } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      const data = {
        labels: this.removeResidentsIfNeeded(['Visitors', 'Residents', 'Staff', 'Contractors', 'Industry Professionals', 'Agencies', 'Volunteers', 'Other']),
        datasets: [{
          data: this.removeResidentsIfNeeded([
            json.visitors,
            json.residents,
            json.staff,
            json.contractors,
            json.industry_professionals,
            json.agencies,
            json.volunteers,
            json.other
          ]),
          backgroundColor: this.removeResidentsIfNeeded(['#eee622', '#22ee80', '#222aee', '#ee2290', '#b80c09', '#20c7d4', '#ff8819', '#8826bf'])
        }],
      }

      const options = {}

      const baseLicense = localStorage.license === "base"

      return (
        <div className="widget">
          <h3>People on Site chart</h3>
          { baseLicense && <h3 className="fire-log-title"><FontAwesomeIcon icon={faBell} /> Fire Log</h3> }
          <Pie data={data} width={500} height={300} options={options} />
        </div>
      );
    }
  }

  state = {
    json: [],
    hideResidents: false,
    loaded: false,
    error: null,
    unauthorized: null
  };

  componentDidMount() {
    let id = this.props.id;

    request("GET", `/v1/a/locations/${id}/people_on_site`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ json: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))

    this.setState({
      hideResidents: hideResidentsCheck()
    })
  }
}

export default PeopleOnSite;
